var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _variableMap;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';

import { css, StyleSheet } from '@patternfly/react-styles';
import styles from '../../@patternfly/patternfly-next/components/BackgroundImage/background-image.css.js';

/* eslint-disable camelcase */
import { c_background_image_BackgroundImage_lg, c_background_image_BackgroundImage_md, c_background_image_BackgroundImage_md_2x, c_background_image_BackgroundImage_sm, c_background_image_BackgroundImage_sm_2x, c_background_image_BackgroundImage_xl, c_background_image_BackgroundImage_xs, c_background_image_BackgroundImage_xs_2x, c_background_image_Filter } from '@patternfly/react-tokens';

export var BackgroundImageSrc = {
  lg: 'lg',
  md: 'md',
  md2x: 'md2x',
  sm: 'sm',
  sm2x: 'sm2x',
  xl: 'xl',
  xs: 'xs',
  xs2x: 'xs2x',
  filter: 'filter'
};

var variableMap = (_variableMap = {}, _defineProperty(_variableMap, BackgroundImageSrc.lg, c_background_image_BackgroundImage_lg && c_background_image_BackgroundImage_lg.name), _defineProperty(_variableMap, BackgroundImageSrc.md, c_background_image_BackgroundImage_md && c_background_image_BackgroundImage_md.name), _defineProperty(_variableMap, BackgroundImageSrc.md2x, c_background_image_BackgroundImage_md_2x && c_background_image_BackgroundImage_md_2x.name), _defineProperty(_variableMap, BackgroundImageSrc.sm, c_background_image_BackgroundImage_sm && c_background_image_BackgroundImage_sm.name), _defineProperty(_variableMap, BackgroundImageSrc.sm2x, c_background_image_BackgroundImage_sm_2x && c_background_image_BackgroundImage_sm_2x.name), _defineProperty(_variableMap, BackgroundImageSrc.xl, c_background_image_BackgroundImage_xl && c_background_image_BackgroundImage_xl.name), _defineProperty(_variableMap, BackgroundImageSrc.xs, c_background_image_BackgroundImage_xs && c_background_image_BackgroundImage_xs.name), _defineProperty(_variableMap, BackgroundImageSrc.xs2x, c_background_image_BackgroundImage_xs_2x && c_background_image_BackgroundImage_xs_2x.name), _defineProperty(_variableMap, BackgroundImageSrc.filter, c_background_image_Filter && c_background_image_Filter.name), _variableMap);

export var propTypes = {
  /** Additional classes added to the background. */
  className: PropTypes.string,
  /** Override image styles using a string or BackgroundImageSrc */
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    lg: PropTypes.string,
    md: PropTypes.string,
    md2x: PropTypes.string,
    sm: PropTypes.string,
    sm2x: PropTypes.string,
    xl: PropTypes.string,
    xs: PropTypes.string,
    xs2x: PropTypes.string,
    filter: PropTypes.string
  })]).isRequired
};

export var defaultProps = {
  className: ''
};

var BackgroundImage = function BackgroundImage(_ref) {
  var className = _ref.className,
      src = _ref.src,
      props = _objectWithoutProperties(_ref, ['className', 'src']);

  // Default string value to handle all sizes
  var variableOverrides = typeof src === 'string' ? Object.keys(BackgroundImageSrc).reduce(function (prev, size) {
    return _extends({}, prev, _defineProperty({}, BackgroundImageSrc[size], src));
  }, {}) : src;

  var bgStyles = StyleSheet.create({
    bgOverrides: '&.pf-c-background-image {\n      ' + Object.keys(variableOverrides).reduce(function (prev, size) {
      return '' + (prev.length ? prev : '') + variableMap[size] + ': url(\'' + variableOverrides[size] + '\');';
    }, {}) + '\n    }'
  });

  return React.createElement('div', { className: css(styles.backgroundImage, bgStyles.bgOverrides, className) });
};

BackgroundImage.propTypes = propTypes;
BackgroundImage.defaultProps = defaultProps;
export default BackgroundImage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/BackgroundImage/BackgroundImage.js
// module id = 214
// module chunks = 0